<template>
	<div class="self-signup-message">
		<v-icon size="64" color="grey darken-1">mdi-clock-alert-outline</v-icon>
		<h1 class="mt-4 mb-3">Lien expiré</h1>
		<p class="text-center message-body">
			Ce lien a expiré, veuillez contacter votre administrateur pour en obtenir un nouveau.
		</p>
	</div>
</template>

<script>
export default {
	name: 'SelfSignupExpired',
};
</script>

<style lang="scss" scoped>
.self-signup-message {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	min-height: 40vh;
	text-align: center;
	padding: 24px;
}
.message-body {
	max-width: 420px;
	color: #555;
}
</style>
